import commonMixin from '@/mixins/common';
import { drawerWidth, drawerWidth_xl } from '@/common/constants';

export default {
  mixins: [commonMixin],
  data: () => ({
    mousePos: { x: 0, y: 0 },
    drawing: false,
    lastPos: { x: 0, y: 0 },
    canvas: undefined,
    ctx: undefined,
    painted: false,
    initialState: true,
    cellWidth: 0,
    cellHeight: 0,
    canvasBitmap: null,
  }),
  mounted() {
    this.canvas = document.getElementById('sig-canvas-' + this.key);
    this.ctx = this.canvas.getContext('2d');
    this.ctx.strokeStyle = '#000';
    this.ctx.lineWidth = 2;

    window.addEventListener('resize', this.handleResize);
    document.addEventListener('visibilitychange', this.handleVisibilityChange);
    this.handleResize();

    this.showSignature();
  },
  created() {
    if (this.editorModel[this.key] === undefined) {
      //Make value reactive if not set yet
      this.$set(this.editorModel, this.key, undefined);
    }
  },
  updated() {
    //Update signature from report on change form
    this.showSignature();
  },
  computed: {
    borderOutline() {
      let prop = this.themeName;
      if (this.cell === undefined && !this.initialState && !this.painted) {
        //Show outline only red if is not initial state and editor is used in form view, not unfalldesk
        prop = 'error';
      }
      return `outlined-${prop}`;
    },
  },
  methods: {
    setCellWidth() {
      this.cellWidth = this.$refs['sig-cell-' + this.key].clientWidth;
    },
    setCellHeight() {
      this.cellHeight = this.cell && this.cell.height && this.cell.height >= 500 ? this.cellWidth * 0.8 : this.cellWidth * 0.4;
    },
    handleResize() {
      this.setCellWidth();
      this.setCellHeight();

      this.canvas.width = this.cellWidth;
      this.canvas.height = this.cellHeight;
      this.restoreCanvas();
    },
    showSignature() {
      if (this.editorModel[this.key] !== undefined) {
        //Show signature from report
        const image = new Image();
        image.onload = function () {
          this.ctx.drawImage(image, 0, 0, this.cellWidth, this.cellHeight);
        }.bind(this);
        if (this.editorModel[this.key]) {
          image.src = this.editorModel[this.key];
          this.painted = true;
        }
      } else {
        this.ctx.fillStyle = '#fff';
        this.ctx.fillRect(0, 0, this.canvas.width, this.canvas.height);
      }
    },
    getMousePos(e) {
      const rect = this.canvas.getBoundingClientRect();
      if (e.touches === undefined) {
        //Is Mouse Event
        return {
          x: e.clientX - rect.left,
          y: e.clientY - rect.top,
        };
      } else {
        //Is Touch Event
        return {
          x: e.touches[0].clientX - rect.left,
          y: e.touches[0].clientY - rect.top,
        };
      }
    },
    onMouseDown(e) {
      this.drawing = true;
      this.lastPos = this.getMousePos(e);
      this.painted = true;
      this.initialState = false;
    },
    onMouseMove(e) {
      e.preventDefault();
      if (!this.readonly) {
        this.mousePos = this.getMousePos(e);
        if (this.drawing) {
          this.ctx.moveTo(this.lastPos.x, this.lastPos.y);
          this.ctx.lineTo(this.mousePos.x, this.mousePos.y);
          this.ctx.stroke();
          this.lastPos = this.mousePos;
        }
      }
    },
    onMouseUp() {
      if (this.drawing === true) {
        this.drawing = false;

        //Save to model
        this.editorModel[this.key] = this.canvas.toDataURL('image/jpeg', 1.0);
      }
    },
    clearPaint() {
      this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);
      this.ctx.beginPath(); //Resets the drawing
      this.ctx.fillStyle = '#fff';
      this.ctx.fillRect(0, 0, this.canvas.width, this.canvas.height);
    },
    onClear() {
      this.clearPaint();
      this.painted = false;
      this.editorModel[this.key] = undefined;
    },
    handleVisibilityChange() {
      if (document.visibilityState === 'hidden') {
        createImageBitmap(this.canvas).then((bmp) => {
          this.canvasBitmap = bmp;
        });
      } else if (document.visibilityState === 'visible' && this.canvasBitmap) {
        this.ctx.globalCompositeOperation = 'copy';
        this.ctx.drawImage(this.canvasBitmap, 0, 0);
        this.ctx.globalCompositeOperation = 'source-over';
      }
    },
    restoreCanvas() {
      if (this.canvasBitmap) {
        this.ctx.drawImage(this.canvasBitmap, 0, 0);
      } else {
        this.showSignature();
      }
    },
  },
  watch: {
    cellWidth() {
      this.showSignature();
    },
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
    document.removeEventListener('visibilitychange', this.handleVisibilityChange);
  },
};
